export default __webpack_public_path__ + "static/media/Add-Address.e8ed39e0.jpg";